import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 5,
    "name": "Maďarský jazyk",
    "locale": "hu",
    "image": {
      "id": 5,
      "name": "hu.svg",
      "url": "https://api.oszlopok.hu/files/hu.svg?ai=0",
      "custom_title": "hu",
      "is_ai_generated": false
    },
    "is_default": true
  }
];
